// extracted by mini-css-extract-plugin
module.exports = {"policy":"page_policy__fF5MN","updated":"page_updated__5f_h1","details":"page_details__w_wbI","document":"page_document__Obxcb"};